import React, { useState, useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import config from "../../Config";
import axios from "axios";
import { Form } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StudentMenu from "./StudentMenu";
import ShowStudent from "../Shared/ShowStudent";
import Pagination from "../General/Pagination";
import RightsCheck from "../General/RightsCheck";
import { scrollToTop } from "../Shared/ScrollOnTop";
import moment from "moment";

const MONTH_OPTIONS = [
  { value: 0, label: "All months" },
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

function yearOptions() {
  const y = new Date().getFullYear();
  const opts = [{ value: 0, label: "All years" }];
  for (let i = y - 8; i <= y + 2; i++) {
    opts.push({ value: i, label: String(i) });
  }
  return opts;
}

function normalizeChallanListRow(raw) {
  if (!raw || typeof raw !== "object") return null;
  const str = (a, b) => {
    const v = raw[a] ?? raw[b];
    if (v == null || v === "") return null;
    return String(v);
  };
  const num = (a, b, d = 0) => {
    const v = raw[a] ?? raw[b];
    const n = Number(v);
    return Number.isFinite(n) ? n : d;
  };
  return {
    ID: num("ID", "id", 0),
    Challan_No: str("Challan_No", "challan_No"),
    Registration_No: str("Registration_No", "registration_No"),
    Student_ID: num("Student_ID", "student_ID", 0),
    Student_Name: str("Student_Name", "student_Name"),
    Father_Name: str("Father_Name", "father_Name"),
    Wing_Name: str("Wing_Name", "wing_Name"),
    Class_Name: str("Class_Name", "class_Name"),
    Section_Name: str("Section_Name", "section_Name"),
    Month: num("Month", "month", 0),
    Year: num("Year", "year", 0),
    Is_Paid: Boolean(raw.Is_Paid ?? raw.is_Paid),
    ChallanStatus: str("ChallanStatus", "challanStatus"),
    Due_Date_Amount: num("Due_Date_Amount", "due_Date_Amount", 0),
    Payment_Date: raw.Payment_Date ?? raw.payment_Date ?? null,
  };
}

function formatPaymentDate(item) {
  if (!item?.Is_Paid || !item.Payment_Date) return "";
  const m = moment(item.Payment_Date);
  return m.isValid() ? m.format(config.date_format) : "";
}

function StudentChallanList() {
  const params = useParams();
  const studentId = parseInt(params.id, 10) || 0;

  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [validated, setValidated] = useState(false);
  const [showFilters, setShowFilters] = useState(true);

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [totalRecords, setTotalRecords] = useState(0);

  const [filterChallanNo, setFilterChallanNo] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(0);
  const [fYear, setFYear] = useState(0);
  const [paymentStatus, setPaymentStatus] = useState("");
  const [challanTypeFilter, setChallanTypeFilter] = useState("");
  const [OrderBy, setOrderBy] = useState("Dated");

  useEffect(() => {
    document.title = "Student challan listing";
  }, []);

  useEffect(() => {
    if (studentId <= 0) return;

    let cancelled = false;
    setLoading(true);

    axios({
      method: "post",
      url: config.base_url + "ChallanFeeSystem/SearchChalanHeads",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType,
        pageNo,
        pageSize,
        SessionID: 0,
        Wing_Id: 0,
        Class_Id: 0,
        Section_Id: 0,
        Registration_No: "",
        Challan_No: filterChallanNo.trim(),
        Student_ID: studentId,
        Keywords: "",
        SelectedMonth: selectedMonth,
        FYear: fYear,
        PaymentStatus: paymentStatus,
        ChallanTypeFilter: challanTypeFilter,
        OrderBy,
      },
      timeout: 60000,
    })
      .then((response) => {
        if (cancelled) return;
        if (response.data?.status_code === 1) {
          const list = response.data.ListofRecords || [];
          setRows(list.map(normalizeChallanListRow).filter(Boolean));
          setTotalRecords(response.data.totalRecords || 0);
        } else {
          setRows([]);
          setTotalRecords(0);
          if (response.data?.status_message) {
            toast.error(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
      })
      .catch(() => {
        if (!cancelled) {
          setRows([]);
          setTotalRecords(0);
          toast.error("Network error loading challans.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [
    studentId,
    pageNo,
    pageSize,
    filterChallanNo,
    selectedMonth,
    fYear,
    paymentStatus,
    challanTypeFilter,
    OrderBy,
    AccessKey,
    UserID,
    MemberType,
  ]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setPageNo(1);
    setValidated(true);
    scrollToTop();
  };

  const renderRows = () => {
    if (!rows.length) {
      return (
        <tr>
          <td colSpan={12}>
            <h4
              className="mt-3 mb-0"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No challans found for this student
            </h4>
          </td>
        </tr>
      );
    }

    return rows.map((item, idx) => {
      const rowKey = `ch-${item.ID}-${item.Month}-${item.Year}-${item.Challan_No || ""}-${idx}`;
      return (
        <tr key={rowKey}>
          <td>{item.Challan_No || item.ID}</td>
          <td>{item.Registration_No}</td>
          <td>{item.Student_Name}</td>
          <td>{item.Father_Name}</td>
          <td>{item.Wing_Name}</td>
          <td>{item.Class_Name}</td>
          <td>{item.Section_Name}</td>
          <td>
            {item.Month}/{item.Year}
          </td>
          <td className="text-end text-nowrap">
            Rs.&nbsp;
            {Number(item.Due_Date_Amount ?? 0).toLocaleString(undefined, {
              maximumFractionDigits: 0,
            })}
          </td>
          <td>
            {item.Is_Paid ? (
              <span className="text-success">Paid</span>
            ) : (
              <span className="text-danger">Unpaid</span>
            )}
          </td>
          <td className="text-nowrap">
            {formatPaymentDate(item) || "—"}
          </td>
          <td>{item.ChallanStatus || "—"}</td>
        </tr>
      );
    });
  };

  if (studentId <= 0) {
    return (
      <>
        <StudentMenu />
        <div className="container body-content p-4">
          <div className="alert alert-warning">Invalid student id.</div>
        </div>
      </>
    );
  }

  return (
    <>
      <StudentMenu />
      <RightsCheck />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-8">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/students/SearchStudents">Students</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Challan listing
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Student challan listing</div>
                <p className="text-muted small mb-0">
                  View-only list of challans for this student (all statuses — normal, left,
                  struck off, etc.). No edit, print, or delete actions here.
                </p>
              </div>
              <div className="col-md-4">
                <div className="page-right-actions">
                  <NavLink
                    to={`/Students/StudentLedger/${studentId}`}
                    className="button button-white me-2"
                  >
                    <i className="ri-pages-line" /> Old ledger
                  </NavLink>
                  <button
                    type="button"
                    onClick={() => setShowFilters((p) => !p)}
                    className="button button-white button-icon"
                  >
                    {showFilters ? "Hide filters" : "Show filters"}
                    <i className="ri-filter-3-line" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <ShowStudent StudentID={studentId} />

            <div className={`collapse ${showFilters ? "show" : ""}`}>
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <div className="card mb-2">
                  <div className="card-body p-md-4">
                    <div className="row align-items-end gy-3">
                      <div className="col-md-3">
                        <label className="form-label">Challan no</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Partial match"
                          value={filterChallanNo}
                          onChange={(e) => setFilterChallanNo(e.target.value)}
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Month</label>
                        <select
                          className="form-select"
                          value={selectedMonth}
                          onChange={(e) =>
                            setSelectedMonth(parseInt(e.target.value, 10) || 0)
                          }
                        >
                          {MONTH_OPTIONS.map((m) => (
                            <option key={m.value} value={m.value}>
                              {m.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Year</label>
                        <select
                          className="form-select"
                          value={fYear}
                          onChange={(e) =>
                            setFYear(parseInt(e.target.value, 10) || 0)
                          }
                        >
                          {yearOptions().map((y) => (
                            <option key={y.value} value={y.value}>
                              {y.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Payment</label>
                        <select
                          className="form-select"
                          value={paymentStatus}
                          onChange={(e) => setPaymentStatus(e.target.value)}
                        >
                          <option value="">All</option>
                          <option value="Paid">Paid</option>
                          <option value="Unpaid">Unpaid</option>
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Challan type</label>
                        <select
                          className="form-select"
                          value={challanTypeFilter}
                          onChange={(e) => setChallanTypeFilter(e.target.value)}
                        >
                          <option value="">All types</option>
                          <option value="Monthly">Monthly only</option>
                          <option value="Admission">Admission only</option>
                        </select>
                      </div>
                      <div className="col-md-2">
                        <button
                          type="submit"
                          className="button button-primary w-100"
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>

            <div className="card mt-2">
              <div className="card-body">
                <table className="table table-theme">
                  <thead>
                    <tr>
                      <th>Challan no</th>
                      <th>Reg no</th>
                      <th>Name</th>
                      <th>Father</th>
                      <th>Wing</th>
                      <th>Class</th>
                      <th>Section</th>
                      <th>Period</th>
                      <th className="text-end">Amount (Rs.)</th>
                      <th>Payment</th>
                      <th>Payment date</th>
                      <th>Challan status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td className="text-center" colSpan={12}>
                          <Spinner animation="border" role="status" />
                        </td>
                      </tr>
                    ) : (
                      renderRows()
                    )}
                  </tbody>
                </table>
                {totalRecords > 0 && (
                  <div className="pagination-wrap">
                    <div className="row align-items-center mb-2">
                      <div className="col-md-2">
                        <label className="me-2">Page size</label>
                        <select
                          className="form-select d-inline-block"
                          style={{ width: "100px" }}
                          value={pageSize}
                          onChange={(e) => {
                            setPageNo(1);
                            setPageSize(parseInt(e.target.value, 10));
                          }}
                        >
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>
                      </div>
                    </div>
                    {totalRecords > pageSize && (
                      <Pagination
                        pageNo={pageNo}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        onPageChange={setPageNo}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentChallanList;
